import { cloneDeep } from 'lodash';
import { useState } from 'react';
import type { AdAccountsSelection, BusinessAccount } from './types';

export const AdsAccountSelector = ({
  adAccounts,
  setAdAccounts,
  selectedBusinessAccount,
}: {
  adAccounts: AdAccountsSelection;
  setAdAccounts: React.Dispatch<React.SetStateAction<AdAccountsSelection>>;
  selectedBusinessAccount: BusinessAccount;
}) => {
  const [search, setSearch] = useState('');

  const handleSelect = (item: {
    name: string;
    id: string;
    selected: boolean;
  }) => {
    setAdAccounts((prev) => {
      const out = cloneDeep(prev);

      const updated = out[selectedBusinessAccount.id]?.find(
        (old) => old.id === item.id
      );
      if (updated) {
        updated.selected = !!!updated?.selected;
      }
      return out;
    });
  };

  const selectedAdAccounts = adAccounts[selectedBusinessAccount.id];

  const filteredSelectedAdAccounts = search
    ? selectedAdAccounts?.filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.id.toLowerCase().includes(search.toLowerCase())
      )
    : selectedAdAccounts;

  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="flex text-black text-opacity-50">Ad Accounts:</p>
        <input
          type="text"
          className="w-64 h-6 rounded-lg border-segments-gray"
          placeholder="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="mt-4 overflow-y-auto lg:h-44">
        {filteredSelectedAdAccounts?.map((item) => (
          <div key={item.id} className="">
            <input
              name={item.id}
              id={item.id}
              className="w-4 h-4 mr-2 rounded-sm cursor-pointer focus:ring-0 text-segments-accent-color-1"
              type="checkbox"
              checked={item.selected}
              onChange={() => handleSelect(item)}
            />
            <label htmlFor={item.id}>
              {`${item.name.replaceAll('_' || '-', ' ')}`}
              <span className="text-xs"> ({item.id})</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
